import { useState, useEffect } from 'react';
import { useStoreState } from '../../../models/RootStore';

export const useUserPreferences = () => {
  const types = useStoreState((s) => s.types);
  const [lists, setLists] = useState({
    temperatureScaleOptions: [],
    timeFormatOptions: [],
    dateFormatOptions: []
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!types?.temperatureScale) {
      setIsLoading(false);
      return;
    }

    const { temperatureScale: tempOptions } = types;
    const dropdownkeys = Object.keys(tempOptions);
    const dropdownOptions = [];

    dropdownkeys.forEach((key) => {
      if (tempOptions[key] !== "unknown") {
        const text = tempOptions[key];
        dropdownOptions.push({
          value: +key,
          label: text.charAt(0).toUpperCase() + text.slice(1)
        });
      }
    });

    const timeOptions = types.timeFormat.map((item) => ({
      value: item.value,
      label: item.text
    }));

    const dateOptions = types.dateFormat.map((item) => ({
      value: item.value,
      label: item.text
    }));

    setLists({
      temperatureScaleOptions: dropdownOptions,
      timeFormatOptions: timeOptions,
      dateFormatOptions: dateOptions
    });
    setIsLoading(false);
  }, [types]);

  return { lists, isLoading };
};
